import type { CompleteTheme as ThemeWithSpecialty } from 'foundations-theming-base/complete-theme-type';
import { Color } from 'foundations-theming-base/types';

import { useTheme as rawUseTheme } from './useTheme';
import { css as rawCss } from './css';
import {
  CSSObject,
  FlattenInterpolation,
  Interpolation,
  InterpolationFunction,
  ThemedStyledInterface,
  ThemedStyledProps,
} from 'styled-components';
import { styledWithTheme as rawStyledWithTheme } from './styledWithTheme';
import { ComponentType, type JSX } from 'react';
import { withTheme as rawWithTheme } from './withTheme';

type SpecialtyCss = <P extends object = {}>(
  first:
    | TemplateStringsArray
    | CSSObject
    | InterpolationFunction<ThemedStyledProps<P, ThemeWithSpecialty>>,
  ...interpolations: Array<
    Interpolation<ThemedStyledProps<P, ThemeWithSpecialty>>
  >
) => FlattenInterpolation<ThemedStyledProps<P, ThemeWithSpecialty>>;

type SpecialtyWithTheme = <
  T extends {
    theme?: ThemeWithSpecialty | undefined;
  },
>(
  WrappedComponent: ComponentType<T>
) => {
  (
    props: Omit<T, 'theme'> & {
      theme?: ThemeWithSpecialty | undefined;
    }
  ): JSX.Element;
  displayName: string;
};

type SpecialtyStyledInterface = ThemedStyledInterface<ThemeWithSpecialty>;

const css = rawCss as unknown as SpecialtyCss;

const useTheme = rawUseTheme as unknown as () => ThemeWithSpecialty;

const withTheme = rawWithTheme as unknown as SpecialtyWithTheme;

const styledWithTheme =
  rawStyledWithTheme as unknown as SpecialtyStyledInterface;

export { css, useTheme, withTheme };

export default styledWithTheme;

export type ThemeWithSpecialtyColor = keyof ThemeWithSpecialty['color'];

export type SpecialtyColor = Exclude<ThemeWithSpecialtyColor, Color>;

/** Safely reference a specialty color token to pass to a token property.
 *
 * Use like `<Flex backgroundColor={specialtyColor('breeze-fill-primary-default')}/>`
 */
export function specialtyColor(token: SpecialtyColor): Color {
  return token as Color;
}
